import Vue from 'vue';

const request = async ({
  path,
  session,
  uniqueOrderNumber,
  anonymousUserToken,
  state,
}) => {
  const response = await Vue.axios.post(`/orders/presence/${path}${session}`, {
    unique_order_number: uniqueOrderNumber,
    anonymous_user_token: anonymousUserToken,
    ...(state && { state }),
  });

  return response.data.data;
};

// Records that the guest is on this order, and refreshes it on every repeat
// call. Presence expires on its own, so this has to keep being sent while they
// are still there.
export const recordOrderPresenceRequest = async payload =>
  request({ path: '', ...payload });

export const releaseOrderPresenceRequest = async payload =>
  request({ path: 'release/', ...payload });
